export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-thumbnail-v1-480-a83093795b95d49566e32d318542922f.png";